import setCurrentPage from "src/Utils/setCurrentPage";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import "./index.sass";

const HeaderCenter = () => {
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  return (
    <>
      {currentPage !== 0 && (
        <div className="header-center">
          <div className="header-center-circle" onClick={() => setCurrentPage(0)}>
            <svg
              style={{ width: "var(--width-12)" }}
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="14"
              viewBox="0 0 13 14"
              fill="none"
            >
              <path
                d="M0.0253906 13.1851V4.68506L6.02539 0.435059L12.0254 4.68506V13.1851H7.52539V8.22673H4.52539V13.1851H0.0253906Z"
                fill="black"
              />
            </svg>
          </div>
          <div className={`header-center-circle ${currentPage === 2 ? "disabled" : ""}`} onClick={() => setCurrentPage(2)}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" style={{ width: "var(--width-18)" }} viewBox="0 0 1920 1920">
              <path
                d="M960 0v213.333c411.627 0 746.667 334.934 746.667 746.667S1371.627 1706.667 960 1706.667 213.333 1371.733 213.333 960c0-197.013 78.4-382.507 213.334-520.747v254.08H640V106.667H53.333V320h191.04C88.64 494.08 0 720.96 0 960c0 529.28 430.613 960 960 960s960-430.72 960-960S1489.387 0 960 0"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </div>
      )}
    </>
  );
};

export default HeaderCenter;
